import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import { applyMiddleware, createStore } from "redux";
import thunk from "redux-thunk";

import { App } from "./components/App";
import reducers from "./reducers";

import "antd/dist/antd.css";
import "bootstrap/dist/css/bootstrap.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-table/react-table.css";

// State Persistence
const saveToLocalStorage = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem("state", serializedState);
  } catch (e) {
    console.log(e);
  }
};

const loadFromLocalStorage = () => {
  try {
    const serializedState = localStorage.getItem("state");
    if (serializedState === null) return undefined;
    return JSON.parse(serializedState);
  } catch (e) {
    console.log(e);
    return undefined;
  }
};

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return <h1 style={{ color: "red", textAlign: "center" }}>Something went wrong.</h1>;
    }
    return this.props.children;
  }
}
const persistedState = loadFromLocalStorage();
const store = createStore(reducers, persistedState, applyMiddleware(thunk));
store.subscribe(() => saveToLocalStorage(store.getState()));

// ✅ Use Router here
ReactDOM.render(
  <ErrorBoundary>
  <Provider store={store}>
    <Router>
      <App />
    </Router>
  </Provider>
  </ErrorBoundary>,
  document.getElementById("root")
);
